import fly from 'flyio'
// 宿舍安全管理协议
export const protocolAPI = (params) =>
  fly.get(`/mall/common/protocol.json`, { ...params })
